import React from 'react'
import { Alert } from 'antd'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'

interface Props {
  message?: string
  description?: any
  banner?: boolean
  closable?: boolean
  type?: string
  showIcon?: boolean
}

const AlertInfo: React.FC<Props> = ({
  message,
  description,
  banner = false,
  closable = false,
  showIcon = false,
}) => {
  return (
    <MyAlert
      message={message}
      description={description}
      banner={banner}
      closable={closable}
      type="info"
      showIcon={showIcon}
    />
  )
}

const MyAlert = styled(Alert)`
  background-color: ${(props: { theme: MyTheme }): string => props.theme.colors.primary}1f;
`

export default AlertInfo
